import { render, staticRenderFns } from "./VendaAvulsa.vue?vue&type=template&id=70ad8f50"
import script from "./VendaAvulsa.vue?vue&type=script&lang=js"
export * from "./VendaAvulsa.vue?vue&type=script&lang=js"
import style0 from "./VendaAvulsa.vue?vue&type=style&index=0&id=70ad8f50&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports